import styled from 'src/styles/theme';
import { CarNumberStyled } from '../CarNumberStyled';
import { rem } from 'polished';
export const CarNumberStyledOVGB = styled(CarNumberStyled)`
    color: ${({ theme }) => theme.colors.grey1};
    font-size: ${rem('12px')};
`;
